import { ChangeDetectionStrategy, Component, SimpleChanges } from '@angular/core';
import { CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { SelectBoxComponent } from '@app/customizer/components/select-box/select-box';
import { MiscModel } from '@models/misc-model';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationService } from '@services/configuration.service';
import { UserService } from '@services/user.service';
import { ModelsService } from '@services/v2/models.service';
import { ModelModel } from '@models/api-models/model';
import { ComponentVariantModel } from '@models/component-variant';
import { ConfigurationModel } from '@models/configuration';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';
import { ModelGroupModel } from '@models/model-group';
import { EventsService } from '@services/events.service';
import { ImageService, ImageSize } from '@services/image.service';
import { DataApiService } from '../../../../_services/data-api.service';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
	selector: 'model',
	styleUrls: ['./model.scss'],
	template: `
		<div class="wrapper">
			<div class="header">
				<customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)"></customizer-component-header>
				<button (click)="toggleExpanded()" class="btn btn-secondary btn-short hidden-xs">{{"CUSTOMIZER.COMPONENTS.MODEL." +  (this.menuService.subMenuIsExpanded ? "MINIMIZE" : 'EXPAND') | translate}}</button>
			</div>
			<select-box
				[imageClass]="'model'"
				[options]="models"
				optionsText="Code"
				optionsDescription2="Description2"
				optionsId="Uuid"
				[editMode]="state === customizerStateEnum.EDITORDER"
				[selected]="model"
				[optionsImage]="getImage"
				(selectedChange)="onSelect($event)"
				[optionsDiscontinued]="'Discontinued'"
				[expanded]="this.menuService.subMenuIsExpanded"
				[colorMatchMode]="false"
				[matchColor]="menu.matchColor"
			></select-box>
		</div>
		`,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [SelectBoxComponent, CustomizerComponentHeaderComponent, TranslatePipe]
})
export class ModelComponent extends BaseCustomizerComponent {

	public models: Array<ModelModel | null> | undefined;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		private userService: UserService,
		private imageService: ImageService,
		private modelsService: ModelsService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	public static override shouldBeVisible = (modelGroup: ModelGroupModel | undefined, menuComponents: CustomizerMenuPartModel, variants: Array<ComponentVariantModel> | undefined, configurations: Array<ConfigurationModel>, demo: boolean, chosenCase?: MiscModel | null): boolean => {
		return true;
	}

	onChanges(changes: SimpleChanges) {
	}

	async initData() {
		this.events.showLoader(true, 0);

		this.models = await this.fetchData();

		this.events.showLoader(false, 0);
	}

	onSelect(model: ModelModel) {
		this.events.showLoader(true, 0);
		this.updateModel(model);

		// if (this.menu.menuDetails.expanded) {
		// 	this.menu.menuDetails.expanded = false;
		// 	setTimeout(() => {
		// 		var element = document.getElementsByClassName('is-selected')
		// 		if (element && element[0]) {
		// 			element[0].scrollIntoView();
		// 		}
		// 	}, 1500);
		// }

		if (this.menuService.subMenuIsExpanded) {
			this.menuService.setSubMenuIsExpanded(false);

			setTimeout(() => {
				var element = document.getElementsByClassName('is-selected')
				if (element && element[0]) {
					element[0].scrollIntoView();
				}
			}, 1500);
		}
	}

	public getImage = (model: ModelModel) => this.imageService.GetFrontImage(model, model.DefaultVariantModels, ImageSize.Medium);

	async fetchData(): Promise<Array<ModelModel | null> | undefined> {
		let models: Array<ModelModel | null> | undefined;
		const user = await this.userService.GetUser();
		const apidata = await this.modelsService.getModels(user, this.modelGroup);
		models = apidata?.filter((item): item is ModelModel => item !== null)
			.sort((a, b) => b.Order.localeCompare(a.Order));

		return models;
	}

}
